import { bootstrapApplication } from '@angular/platform-browser';
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { RouteReuseStrategy, provideRouter } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { LoginService } from './app/services/login.service';
import { MyEventServices } from './app/services/my-event.service';
import { AppSettings } from './app/app-settings';
import { AssignmentService } from './app/services/assignment.service';
import { EventService } from './app/services/event.service';
import { TypesService } from './app/services/types.service';
import { ScheduleService } from './app/services/schedule.service';
import { ReportsService } from './app/services/reports.services';
import { NotificationService } from './app/services/notification.service';
import { MiscService } from './app/services/misc.service';
import { LiveStreamService } from './app/services/livestream.service';
import { AdministrativeService } from './app/services/administrative.service';
import { ProfileService } from './app/services/profile.service';
import { FileService } from './app/services/files.service';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { FcmService } from './app/services/fcm.service';
import { TokenInterceptor } from './app/services/httpInterceptor.service';
import { PaymentService } from './app/services/payment.service';
import { ParishConfigService } from './app/services/parishconfig.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { VisitationService } from './app/services/visitation.service';

if (environment.production) {
  enableProdMode();
}

const bootstrapApp = async () => {
  bootstrapApplication(AppComponent, {
    providers: [
      File, FileOpener,
      AppSettings, LoginService, MyEventServices, EventService, AssignmentService, TypesService, ScheduleService, ReportsService, NotificationService,
      MiscService, LiveStreamService, AdministrativeService, ProfileService, FileService, FcmService, PaymentService, ParishConfigService, VisitationService,
      { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
      { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
      importProvidersFrom(IonicModule.forRoot({}), HttpClientModule, FormsModule),
      provideRouter(routes),
      provideAnimations()
    ],
  });
};

bootstrapApp();

defineCustomElements(window);
